import { createAction } from '../actions';

export const CONVERT_SMILES_TO_MOL_START = 'CONVERT_SMILES_TO_MOL_START';
export const CONVERT_SMILES_TO_MOL_FULFILL = 'CONVERT_SMILES_TO_MOL_FULFILL';
export const CONVERT_SMILES_TO_MOL_REJECT = 'CONVERT_SMILES_TO_MOL_REJECT';
export const CONVERT_SMILES_TO_MOL_RESET_ERROR = 'CONVERT_SMILES_TO_MOL_RESET_ERROR';

export const CONVERT_MOLFILE_TO_MOL_START = 'CONVERT_MOLFILE_TO_MOL_START';
export const CONVERT_MOLFILE_TO_MOL_FULFILL = 'CONVERT_MOLFILE_TO_MOL_FULFILL';
export const CONVERT_MOLFILE_TO_MOL_REJECT = 'CONVERT_MOLFILE_TO_MOL_REJECT';
export const CONVERT_MOLFILE_TO_MOL_RESET_ERROR = 'CONVERT_MOLFILE_TO_MOL_RESET_ERROR';

export const CONVERT_MOL_TO_SMILES_START = 'CONVERT_MOL_TO_SMILES_START';
export const CONVERT_MOL_TO_SMILES_FULFILL = 'CONVERT_MOL_TO_SMILES_FULFILL';
export const CONVERT_MOL_TO_SMILES_REJECT = 'CONVERT_MOL_TO_SMILES_REJECT';
export const CONVERT_MOL_TO_SMILES_RESET_ERROR = 'CONVERT_MOL_TO_SMILES_RESET_ERROR';

export const GET_PUBCHEM_MOL_START = 'GET_PUBCHEM_MOL_START';
export const GET_PUBCHEM_MOL_FULFILL = 'GET_PUBCHEM_MOL_FULFILL';
export const GET_PUBCHEM_MOL_REJECT = 'GET_PUBCHEM_MOL_REJECT';
export const GET_PUBCHEM_MOL_RESET_ERROR = 'GET_PUBCHEM_MOL_RESET_ERROR';

export function convertSmilesToMol(smiles: string) {
  return createAction(CONVERT_SMILES_TO_MOL_START, { smiles });
}

export function resetErrorSmilesToMol() {
  return { type: CONVERT_SMILES_TO_MOL_RESET_ERROR };
}

export function convertMolfileToMol(molfile: string) {
  return createAction(CONVERT_MOLFILE_TO_MOL_START, { molfile });
}

export function resetErrorMolfileToMol() {
  return { type: CONVERT_MOLFILE_TO_MOL_RESET_ERROR };
}

export function convertMolsToSmiles(mols: any, id: string) {
  return createAction(CONVERT_MOL_TO_SMILES_START, { id, mols });
}

export function resetErrorMolToSmiles() {
  return { type: CONVERT_MOL_TO_SMILES_RESET_ERROR };
}

export function getMolByName(nameOrCas: string) {
  return createAction(GET_PUBCHEM_MOL_START, {
    nameOrCas: typeof nameOrCas === 'string' ? nameOrCas.toLowerCase() : '',
  });
}

export function resetErrorMolByName() {
  return { type: GET_PUBCHEM_MOL_RESET_ERROR };
}
